import { AfterViewInit, Directive, OnDestroy } from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import { Subscriptions } from '@k2/common/helpers';

/**
 * Binds to every `<mat-tab-group>` and provides the fix for a
 * "scroll to top" issue which occurs during the tab change event.
 *
 * Workaround for: https://github.com/angular/material2/pull/6812
 */
@Directive({
    selector: 'mat-tab-group',
    standalone: false
})
export class MatTabScrollFixDirective implements AfterViewInit, OnDestroy {
  private readonly scrollElement = document.documentElement;
  private readonly subscriptions = new Subscriptions();
  private scrollPosition: number;
  private tabChanging: boolean;

  constructor(private host: MatTabGroup) {}

  ngAfterViewInit(): void {
    window.addEventListener('scroll', this.scrollHandler);

    this.subscriptions.add(
      this.host.selectedTabChange.subscribe(() => {
        this.tabChanging = false;
        document.documentElement.scrollTop = this.scrollPosition;
      }),
      this.host.selectedIndexChange.subscribe(() => {
        this.tabChanging = true;
      })
    );
  }

  private scrollHandler = () => {
    if (this.tabChanging) {
      this.scrollElement.scrollTop = this.scrollPosition;
    }
    this.scrollPosition = this.scrollElement.scrollTop;
  };

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    window.removeEventListener('scroll', this.scrollHandler);
  }
}
